import { type FormikErrors } from 'formik';
import { type RefObject } from 'react';

import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

import { type FormProps } from './DimensionApprovalFlowPanelContent';

export const validateForm = (
  values: FormProps,
  isApprovalSchemeSetupOpened: boolean,
  panelReference: RefObject<HTMLDivElement | null>,
  t: TGlobalFunctionTyped,
) => {
  const validationErrors: FormikErrors<FormProps> = {};
  if (!values.approvalRules && isApprovalSchemeSetupOpened) {
    validationErrors.approvalRules = t(
      'approvalWorkflows.approvalFlow.pleaseSetUpAnApprovalFlow',
    );
    // Scroll the panel down to see the validation error
    if (panelReference.current) {
      panelReference.current.scrollTo({
        top: panelReference.current.scrollHeight + 200,
        behavior: 'smooth',
      });
    }
  }
  if (values.values === undefined || values.values?.length === 0) {
    validationErrors.values = t(
      'approvalWorkflows.approvalFlow.pleaseSelectAtLeastOneValue',
    );
  }

  const approvalRulesContainDuplicateApprovers = values.approvalRules?.some(
    (approvalRule) => {
      const approverIds = approvalRule.steps.flatMap((step) => {
        return step.rights.map((right) => {
          if (right.approverType === 'user') {
            return `${right.approverType}-${right.approverId}`;
          }
          if (right.approverType === 'reportingManager') {
            return right.approverType;
          }
          return '';
        });
      });
      return approverIds.length !== new Set(approverIds).size;
    },
  );

  if (approvalRulesContainDuplicateApprovers) {
    validationErrors.approvalRules = t(
      'costCenters.form.errors.approvalFlowDuplicateApprovers',
    );
  }

  if (values.approvalRules?.some((rule) => !rule.steps.length)) {
    validationErrors.approvalRules = t(
      'teams.approvalFlows.requiredOneApprover',
    );
  }
  return validationErrors;
};
